package nl.astraeus.wiki.messages

class PingMessage() : Message(
  MessageType.PING,
)
